import React, { useState, useEffect, useRef } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../..//Event/event";

const SquareTheFives = () => {
  const numbers = ["5", "15", "25", "35", "45","55","65"];
  const [eventCompleted, setEventCompleted] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [step, setStep] = useState(1);
  const [firstDigit, setFirstDigit] = useState(null);
  const [multiplyResult, setMultiplyResult] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [showNext, setShowNext] = useState(false);
  const [options, setOptions] = useState([]);
  const [addClicked, setAddClicked] = useState(false);
  const inputRef = useRef(null);

  const currentNumber = numbers[currentIndex];

  useEffect(() => {
    if (step === 1) {
      if (currentNumber === "5") {
        setStep(4);
      } else {
        setOptions(Array.from({ length: 10 }, (_, i) => i));
      }
    } else if (step === 2) {
      const fd = parseInt(currentNumber.slice(0, -1));
      const result = fd * (fd + 1);
      setMultiplyResult(result);
      const randoms = new Set([result]);
      while (randoms.size < 5) randoms.add(Math.floor(Math.random() * 50));
      setOptions(Array.from(randoms).sort(() => 0.5 - Math.random()));
    }
  }, [step, currentNumber]);

  const resetFeedback = () => {
    setFeedback('');
    setFeedbackClass('');
  };

  const handleFirstDigitClick = (val) => {
    const correct = parseInt(currentNumber.slice(0, -1));
    if (val === correct) {
      setFirstDigit(val);
      setFeedback('✅ Correct!');
      setFeedbackClass('correct');
      setTimeout(() => {
        resetFeedback();
        setStep(2);
      }, 1000);
    } else {
      setFeedback('❌ Try again!');
      setFeedbackClass('wrong');
      setTimeout(resetFeedback, 1000);
    }
  };

  const handleMultiplyClick = (val) => {
    if (val === multiplyResult) {
      setFeedback('✅ Great job!');
      setFeedbackClass('correct');
      setTimeout(() => {
        resetFeedback();
        setStep(3);
      }, 1000);
    } else {
      setFeedback('❌ Not quite, try again!');
      setFeedbackClass('wrong');
      setTimeout(resetFeedback, 1000);
    }
  };

  const handleFinalAnswer = () => {
    const expected = currentNumber === "5" ? "25" : `${multiplyResult}25`;
    if (inputValue.trim() === expected) {
      setFeedback(`🎉 Correct! ${currentNumber}² = ${inputValue}`);
      setFeedbackClass('correct');
      setShowNext(true);
    } else {
      setFeedback('❌ That\'s not right, try again!');
      setFeedbackClass('wrong');
    }
  };

  const handleNext = () => {
    if (currentIndex + 1 < numbers.length) {
      setCurrentIndex(currentIndex + 1);
      setStep(1);
      setFirstDigit(null);
      setMultiplyResult(null);
      setFeedback('');
      setFeedbackClass('');
      setInputValue('');
      setShowNext(false);
      setAddClicked(false);
    }
  };

  useEffect(() => {
  if (currentIndex === numbers.length - 1 && showNext && !eventCompleted) {
    const responseData = ConstructorEventUpdateSQLStatus();
    console.log("Event completed", responseData);
    setEventCompleted(true); // Prevent repeated calls
  }
}, [currentIndex, showNext, eventCompleted]);


  const styles = {
    container: {
      fontFamily: "'Comic Neue', cursive, sans-serif",
      background: 'linear-gradient(135deg, #f7cac9, #92a8d1)',
      minHeight: '100vh',
      padding: '4vh 2vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    box: {
      background: '#fff',
      borderRadius: '1.5rem',
      width: '100%',
      maxWidth: '480px',
      padding: '2rem',
      boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
      textAlign: 'center',
      color: '#444',
    },
    title: {
      fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
      marginBottom: '1rem',
      color: '#e94e77',
    },
    number: {
      fontSize: 'clamp(2.5rem, 6vw, 3.5rem)',
      fontWeight: '700',
      color: '#ff6f61',
      marginBottom: '1.5rem',
    },
    step: {
      fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
      marginBottom: '1.5rem',
      minHeight: '50px',
    },
    button: {
      fontSize: 'clamp(1rem, 2.5vw, 1.4rem)',
      background: '#f0f0f0',
      border: '2px solid #ff6f61',
      borderRadius: '0.75rem',
      padding: '0.6rem 1.2rem',
      fontWeight: 700,
      color: '#ff6f61',
      margin: '0.3rem',
      cursor: 'pointer',
    },
    correct: {
      backgroundColor: '#4caf50',
      borderColor: '#388e3c',
      color: 'white',
    },
    wrong: {
      backgroundColor: '#f44336',
      borderColor: '#d32f2f',
      color: 'white',
    },
    inputWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '0.5rem',
      marginTop: '10px',
    },
    input: {
      fontSize: '1.8rem',
      padding: '0.4rem 0.8rem',
      width: '7rem',
      borderRadius: '0.5rem',
      border: '2px solid #e94e77',
      textAlign: 'center',
    },
    submit: {
      fontSize: '1.3rem',
      background: '#ff6f61',
      color: 'white',
      border: 'none',
      borderRadius: '0.6rem',
      padding: '0.6rem 1.2rem',
      cursor: 'pointer',
    },
    nextBtn: {
      backgroundColor: '#ff6f61',
      color: 'white',
      border: 'none',
      padding: '1rem 0',
      width: '100%',
      fontSize: '1.5rem',
      borderRadius: '0.9rem',
      cursor: 'pointer',
      marginTop: '1.5rem',
      boxShadow: '0 6px #c84c6e',
    },
    feedback: {
      fontSize: '1.3rem',
      fontWeight: 700,
      minHeight: '36px',
      marginTop: '0.8rem',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <h1 style={styles.title}>Square the 5s!</h1>
        <div style={styles.number}>{currentNumber}</div>

        <div style={styles.step}>
          {step === 1 && `Step 1: What is the first digit of ${currentNumber}?`}
          {step === 2 && `Step 2: Multiply ${firstDigit} × (${firstDigit + 1}) = ?`}
          {step === 3 && `Step 3: Add 25 at the end!`}
          {step === 4 && `Step 4: What is ${currentNumber} squared?`}
        </div>

        <div>
          {step === 1 && options.map((val) => (
            <button
              key={val}
              style={styles.button}
              onClick={() => handleFirstDigitClick(val)}
            >
              {val}
            </button>
          ))}

          {step === 2 && options.map((val) => (
            <button
              key={val}
              style={styles.button}
              onClick={() => handleMultiplyClick(val)}
            >
              {val}
            </button>
          ))}

          {step === 3 && !addClicked && (
            <button
              style={{ ...styles.button, backgroundColor: '#4caf50', color: 'white' }}
              onClick={() => {
                setAddClicked(true);
                setTimeout(() => setStep(4), 1200);
              }}
            >
              Add 25 ➕
            </button>
          )}

          {step === 3 && addClicked && (
            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>+25 added! 🎉</div>
          )}

          {step === 4 && (
            <div style={styles.inputWrapper}>
              <input
                ref={inputRef}
                style={styles.input}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleFinalAnswer()}
              />
              <button style={styles.submit} onClick={handleFinalAnswer}>Submit</button>
            </div>
          )}
        </div>

        <div style={{ ...styles.feedback, color: feedbackClass === 'correct' ? '#4caf50' : '#f44336' }}>
          {feedback}
        </div>

        {showNext && (
          <button style={styles.nextBtn} onClick={handleNext}>
            {currentIndex + 1 < numbers.length ? 'Next Number ➡️' : 'You did it! 🎉'}
          </button>
        )}
      </div>
    </div>
  );
};

export default SquareTheFives;
